import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { getLoggedUser } from "~/store/selectors/selector.users";
import { isFinancialManager, isOwner } from "~/utils/userHelper";

export const RequireCanSeeUserTimesheet = ({ children, redirectTo }) => {
  const { userId } = useParams();
  const loggedUser = useSelector(getLoggedUser);

  return +userId === loggedUser.id || isOwner(loggedUser) || isFinancialManager(loggedUser) ? (
    children
  ) : (
    <Navigate to={redirectTo} />
  );
};

RequireCanSeeUserTimesheet.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.any,
};

RequireCanSeeUserTimesheet.defaultProps = {
  redirectTo: "/people",
};
